import {Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import {translate} from '@jsverse/transloco';
import { RestoreStatus } from 'src/app/models/restores/restore-status';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { RunbookService } from 'src/app/services/api/runbook.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';

@Component({
  selector: 'app-env-schedule-popup-component',
  templateUrl: './env-schedule-popup-component.html',
  styleUrl: './env-schedule-popup-component.scss',
  standalone: false
})
export class EnvSchedulePopupComponent implements OnInit {
private destroyRef = inject(DestroyRef);
  value: any
  runbook: any;
  instance: any;
  isAWS: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private formBuilder: FormBuilder, public activatedRoute: ActivatedRoute, public instanceService: InstancesService,
    public matdialogRef: MatDialogRef<EnvSchedulePopupComponent>, public runbookService: RunbookService, public tenantService: TenantService) {
  }

  ngOnInit(): void {
    this.value = this.data?.value;
    this.tenantService.tenantData$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        this.isAWS = data === CloudProvider.AWS;
      });
    this.instanceService.getInstanceById(this.data?.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(instanceData => {
        this.instance = instanceData;
      })
      this.runbookService.getRunbookById(this.data?.instanceId, this.value?.runbookId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.runbook = response;
      })
  }
}